<template>
  <div class="card_box">
    <el-tabs v-model="activeName" class="demo-tabs">
      <!--      <el-tab-pane lazy :label="$t('common.setting.general')" name="first">-->
      <!--        <div class="box">-->
      <!--          <div class="title">{{ $t('common.emailbox') }}</div>-->
      <!--          <div class="desc" style="margin-top: 10px;font-size: 13px;">{{ $t('common.emailbox.default') }}</div>-->
      <!--          <el-select-->
      <!--              size="small"-->
      <!--              v-model="defaultEmail"-->
      <!--              @change="handleChangeDefault"-->
      <!--              class="m-2"-->
      <!--              style="min-width: 200px;width:auto;margin-left: 0px !important;"-->
      <!--              :placeholder="$t('common.emailbox.default')"-->
      <!--          >-->
      <!--            <el-option-->
      <!--                v-for="item in emailList"-->
      <!--                :key="item.value"-->
      <!--                :label="item.label"-->
      <!--                :value="item.value"-->
      <!--            />-->
      <!--          </el-select>-->
      <!--          <div class="tips">{{ $t('other.text.bind.default.mailbox') }}</div>-->
      <!--        </div>-->
      <!--      </el-tab-pane>-->
      <el-tab-pane lazy :label="$t('common.emailbox.management')" name="second">
        <div class="box">
          <div class="inner_boxs">
            <div class="title">{{ $t('common.emailbox.bind.manage') }}</div>
            <ElButton size="small" type="primary" @click="handleAdd">{{ $t('common.emailbox.add') }}</ElButton>
          </div>
          <ElTable
                   v-loading="tableLoading"
                   :data="tableData"
                   :header-cell-style="{'text-align': 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px'}">
            <el-table-column prop="username" :label="$t('common.emailbox')" :show-overflow-tooltip="true"/>
            <el-table-column prop="acceptProtocol" :label="$t('common.mailbox.kinds')">
              <template #default="{row}">
                {{ row.mailType === 'auth2' ? toUpperCase(row.oauthType || 'OAuth2') : `${toUpperCase(row.acceptProtocol)} / ${toUpperCase(row.sendProtocol)}`}}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" :label="$t('common.date.add')"/>
            <el-table-column fixed="right" :label="$t('common.operate')" :width="lang==='en'?400:300">
              <template #default="scope">
                <el-button
                    link
                    type="primary"
                    @click="handleAboutBind(scope.row,1)"
                    v-if="scope.row.isBind===0"
                >{{ $t('common.setdefault') }}
                </el-button>
                <el-button
                    link
                    type="warning"
                    @click="handleAboutBind(scope.row,2)"
                    v-else
                >{{ $t('common.rmdefault') }}
                </el-button>
                <el-button
                    link
                    type="primary"
                    @click="handleTest(scope.row)"
                    :disabled="isOAuthMailbox(scope.row)"
                >{{ $t('common.mailbox.test') }}
                </el-button>
                <el-button
                    link
                    type="primary"
                    @click="handleEdit(scope.row)"
                >{{ $t('common.update') }}
                </el-button
                >
                <span class="col">|</span>
                <el-button
                    link
                    type="danger"
                    @click="handleDel(scope.row)"
                >{{ $t('common.unbind') }}
                </el-button
                >
                <span class="col">|</span>
                <el-button
                    type="primary"
                    link
                    @click="handleClickImport(scope.row)"
                >
                  {{ $t('common.setting.mailToImport') }}
                </el-button>
                <!--                <el-button-->
                <!--                    type="primary"-->
                <!--                    link-->
                <!--                    @click="handleClickImport(scope.row,2)"-->
                <!--                >-->
                <!--                  导入已发送-->
                <!--                </el-button>-->
              </template>
            </el-table-column>
            <template #empty>
              <div v-if="tableLoading" style="height: 120px"></div>
              <el-empty v-else :description="$t('common.data.empty')" :image="emptyUrl"/>
            </template>
          </ElTable>
        </div>
      </el-tab-pane>
      <el-tab-pane lazy :label="$t('common.blacklist')" name="third">
        <Card :useBorder="false">
          <div class="box sp">
            <div class="top">
              <div class="titles">{{ $t('common.emailbox.blacklist') }}</div>
              <div class="bottom_input">
                <el-input
                    size="small"
                    v-model="targetEmail"
                    :placeholder="$t('sys.tip.input.blacklist.add.email')"
                    id="sp_input"
                    :clearable="false"
                >
                  <template #suffix>
                    <el-button size="small" type="primary" @click="addBlackEmail" class="sp_btn">{{
                        $t('common.blacklist.add')
                      }}
                    </el-button>
                  </template>
                </el-input>
              </div>
            </div>
            <TablesBlack :table-data="tableDataBackEmail" :table_columns="table_columns_email"
                         @handleDelete="deleteBlackEmail"></TablesBlack>
            <div class="pages">
              <el-pagination
                  size="small"
                  v-model:current-page="blackEmail.current"
                  v-model:page-size="blackEmail.size"
                  background
                  layout="total, prev, pager, next"
                  v-if="blackEmail.total"
                  :total="blackEmail.total"
                  @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </Card>
        <Card :useBorder="false">
          <div class="box sp">
            <div class="top">
              <div class="titles">{{ $t('common.customer.blacklist') }}</div>
              <div class="bottom_input">
                <el-input
                    size="small"
                    v-model="targetCustomer"
                    :placeholder="$t('30004')"
                    id="sp_input"
                    :clearable="false"
                >
                  <template #suffix>
                    <el-button size="small" type="primary" @click="addBlackCustomer" class="sp_btn">{{
                        $t('common.blacklist.add')
                      }}
                    </el-button>
                  </template>
                </el-input>
              </div>
            </div>
            <TablesBlack :table-data="tableDataBackCustomer" :table_columns="table_columns_customer"
                         @handleDelete="deleteBlackCustomer"></TablesBlack>
            <div class="pages">
              <el-pagination
                  size="small"
                  v-model:current-page="blackCustomer.current"
                  v-model:page-size="blackCustomer.size"
                  background
                  layout="total, prev, pager, next"
                  v-if="blackCustomer.total"
                  :total="blackCustomer.total"
                  @current-change="handleCurrentChangeCus"
              />
            </div>
          </div>
        </Card>
      </el-tab-pane>
<!--      <el-tab-pane lazy :label="$t('account_setting.receive_rule')" name="receive-rule">-->
<!--        <ReceiveRule-->
<!--            :rules="receiveRules"-->
<!--            :folder-options="receiveRuleFolderOptions"-->
<!--            :page-no="receiveRulePage.pageNo"-->
<!--            :page-size="receiveRulePage.pageSize"-->
<!--            :total="receiveRulePage.total"-->
<!--            :loading="receiveRuleLoading"-->
<!--            :status-changing-ids="receiveRuleStatusChangingIds"-->
<!--            @create="createReceiveRule"-->
<!--            @edit="editReceiveRule"-->
<!--            @toggle-status="toggleReceiveRuleStatus"-->
<!--            @delete="deleteReceiveRule"-->
<!--            @page-change="handleReceiveRulePageChange"-->
<!--        />-->
<!--      </el-tab-pane>-->
<!--      <el-tab-pane lazy :label="$t('account_setting.auto_reply')" name="auto-reply">-->
<!--        <MailAutoReply-->
<!--            v-model="autoReplySettings"-->
<!--            :mailbox-options="emailList"-->
<!--            :saving="autoReplySaving"-->
<!--            @save="saveAutoReply"-->
<!--        />-->
<!--      </el-tab-pane>-->
    </el-tabs>
    <ReceiveRuleDialog
        v-model="receiveRuleDialogVisible"
        :rule="editingReceiveRule"
        :folder-options="receiveRuleFolderOptions"
        @save="saveReceiveRule"
    />
    <Dialog
        v-model="dialogVisibleInner"
        :width="450"
        :title="$t('sys.team.info')"
        style="min-width: 400px"
        :dialogVisible="dialogVisibleInner"
        :isHeadLine="false"
        @update:dialogVisible="(val) => (dialogVisibleInner = val)"
        align-center
    >
      <template #content>
        <div style="display: flex;justify-content: flex-start;align-items: center">
          <div style="line-height: 23px;margin: 0px 8px 0px 30px;font-size: 14px;">
            {{ $t("import.email.kinds") }}
          </div>
          <el-checkbox-group v-model="checkList">
            <el-checkbox :label="$t('common.emailbox.receive')" :value="1"/>
            <el-checkbox :label="$t('common.email.sendbox')" :value="2"/>
            <!--            <el-checkbox label="同步" :value="3"/>-->
          </el-checkbox-group>
        </div>
        <div class="cont" style="margin-top: 10px">
          <span style="line-height: 24px;margin-right: 30px;">
<!--            <el-icon style="color:#efb041;font-size: 20px;margin-right: 10px;">-->
            <!--              <QuestionFilled/></el-icon>-->
          </span>
          <span style="line-height: 24px;margin-right: 5px;">{{ $t('common.import.des') }}</span>
          <span
              style="font-weight: 600;line-height: 25px;color: #5a9cf8">{{
              `${checkList.includes(1) && checkList.includes(2) ? $t('common.type1') : checkList.includes(1) ? $t('common.emailbox.receive') : checkList.includes(2) ? $t('common.email.sendbox') : $t('email.origin')}`
            }}</span>
          <el-select v-model="valueType" class="m-2" :placeholder="$t('common.select.days')" size="small">
            <el-option
                v-for="item in optionsType"
                :key="item.value"
                :label="item.label"
                :value="item"
            />
          </el-select>
          <span style="line-height: 23px;">{{ $t('common.target.email') }}</span>
        </div>
        <!--        <div v-if="isShowNumber" class="line-text">{{ $t('computed.number') }}</div>-->
        <template v-if="!emailNumberLoading">
          <div v-if="isShowNumber"
               style="padding-left: 30px;display: flex;margin-top: 25px;font-weight: 500;">
            <div>{{ $t('sum.email') }}</div>
            <div v-if="checkList.includes(1)">
              {{ $t('common.import.shou') }}
              <span style="font-weight: 600;color: rgb(90, 156, 248)">{{ emailNumber.inboxNum }}</span>
              {{ $t('common.ph23') }}
            </div>
            <div style="width: 10px;"></div>
            <div style="margin-right: 50px;" v-if="checkList.includes(2)">
              {{ $t('common.import.fa') }}
              <span style="font-weight: 600;color: rgb(90, 156, 248)">{{ emailNumber.sentNum }}</span>
              {{ $t('common.ph23') }}
            </div>
          </div>
          <div v-if="isShowNumber" class="tips_bottom">{{ $t('import.target.email') }}</div>
        </template>
        <div v-else v-loading="emailNumberLoading" style="font-size: 20px;margin: 10px auto;height: 50px;"></div>
      </template>
      <template #footer>
        <div class="settingss">
          <!--          <el-button size="small" @click="dialogVisibleInner = false">{{ $t('common.cancel') }}</el-button>-->
          <el-button size="small" type="info" :loading="emailNumberLoading" @click="handleClickChange">{{
              $t('import.email.all.number')
            }}
          </el-button>
          <el-button size="small" type="primary" @click="handleClickSure" :loading="btnIsLoading">
            {{ $t('common.setting.mailToImport') }}
          </el-button>
        </div>
      </template>
    </Dialog>
    <!-- 选择类型  -->
    <el-dialog
        append-to-body
        width="630px"
        :show-close="false"
        v-model="selectTypeDialog"
        class="mail-provider-el-dialog"
        :close-on-click-modal="false"
        align-center
    >
      <template #header>
        <div class="mail-provider-header">
          <div class="mail-provider-close" @click="selectTypeDialog = false">
            <el-icon>
              <Close />
            </el-icon>
          </div>
          <span class="el-dialog__title">{{ $t('common.system.email.add') }}</span>
          <div class="mail-provider-header-sub" style="display: none;">
            <span>{{ $t('account_setting.mail_provider.subtitle') }}</span>
          </div>
          <div class="mail-provider-header-divider"></div>
        </div>
      </template>

      <div class="mail-provider-dialog">
        <div class="mail-provider-section">
          <div class="mail-provider-section-title">{{ $t('account_setting.mail_provider.section.international') }}</div>
          <div class="mail-provider-grid">
            <div
                class="mail-provider-card"
                v-for="(item, index) in oauthProviderList"
                :key="'oauthProviderList' + index"
                @click="handleSelectOauthProvider(item)"
            >
              <div class="mail-provider-icon-wrap">
                <img class="mail-provider-icon" :src="item.img" alt="" />
              </div>
              <div class="mail-provider-name">{{ item.name }}</div>
            </div>
          </div>
        </div>

        <div class="mail-provider-section" style="margin-top: 16px;margin-bottom: 25px;">
          <div class="mail-provider-section-title">{{ $t('account_setting.mail_provider.section.enterprise') }}</div>
          <div class="mail-provider-grid">
            <div
                class="mail-provider-card"
                v-for="(item, index) in enterpriseProviderList"
                :key="'enterpriseProviderList' + index"
                :class="{ 'mail-provider-card--wide': item.wide }"
                @click="handleSelectEnterpriseProvider(item)"
            >
              <div class="mail-provider-icon-wrap">
                <img class="mail-provider-icon" :src="item.img" alt="" />
              </div>
              <div class="mail-provider-text">
                <div class="mail-provider-name">{{ item.name }}</div>
                <div class="mail-provider-desc" v-if="item.desc">{{ item.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!--  配置  -->
    <el-dialog
        append-to-body
        width="560px"
        v-model="mailConfigDialog"
        :before-close="handleMailConfigDialogCancel"
        :show-close="true"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        align-center
    >
      <template #header>
        <span class="el-dialog__title">
          <span>{{ actionMode === 'edit' ? $t('email.bind.title') : $t('email.bind.write.text') }}</span>
          <span 
            v-if="!isOAuthType" 
            class="search_btn" 
            style="margin-left: 10px;" 
            @click="toHref"
          >
            查看指引
          </span>
        </span>
        <div style="border-bottom: 1px solid #f3f3f3; margin-top: 10px;width: 100%"></div>
      </template>
      <mailLoginForm
          :actionMode="actionMode"
          :initData="rowData"
          showUseWay
          :initMailAccountType="mailAccountType"
          @success="successCb"
      />
    </el-dialog>
    <!--    异步提示正在收录中-->
    <Dialog
        v-model="getEmailDia"
        :width="'420'"
        :dialogVisible="getEmailDia"
        :isHeadLine="false"
        :title="$t('tips')"
        @update:dialogVisible="(val) => (getEmailDia = val)"
        align-center
    >
      <template #content>
        <div class="cont">
          <!--          <span><el-icon style="color:#448ef7;font-size: 20px;margin-right: 10px;"><WarningFilled/></el-icon></span>-->
          <span>{{ $t('common.setting.emailToRemind') }}</span>
        </div>
      </template>
      <template #footer>
        <div class="settingss">
          <el-button size="small" type="primary" @click="()=>getEmailDia = false">{{
              $t('common.data.know')
            }}
          </el-button>
        </div>
      </template>
    </Dialog>
    <!--    测试连通性-->
    <Dialog
        v-model="diaTest"
        :title="$t('common.test.connect.title')"
        :width="'450'"
        :dialogVisible="diaTest"
        @update:dialogVisible="(val) => (diaTest = val)"
        align-center
    >
      <template #content>
        <div class="cont_test">
          <div>{{ isContent ? $t('common.testing') : $t('common.test.finish') }}</div>
          <div>
            <template v-if="isContent">
              <el-icon class="is-loading">
                <Loading/>
              </el-icon>
              <span style="margin-left: 10px">{{ $t("common.connect.send.server") }}({{
                  activeItem.sendProtocol.toLocaleUpperCase()
                }})</span>
            </template>
            <template v-else>
              <template v-if="sendConnect">
                <el-icon style="color: #7ec050;margin-right: 10px">
                  <Select/>
                </el-icon>
                <span style="color: #7ec050">{{
                    activeItem.sendProtocol.toLocaleUpperCase()
                  }} {{ $t('common.connect.server.success') }}</span>
              </template>
              <template v-else>
                <el-icon style="color: #e47470;margin-right: 10px">
                  <CloseBold/>
                </el-icon>
                <span style="color: #e47470">{{
                    activeItem.sendProtocol.toLocaleUpperCase()
                  }} {{ $t("common.connect.server.fail") }}</span>
              </template>
            </template>
          </div>
          <div>
            <template v-if="isContent">
              <el-icon class="is-loading">
                <Loading/>
              </el-icon>

              <span style="margin-left: 10px">{{ $t("common.connect.get.server") }}({{
                  activeItem.acceptProtocol.toLocaleUpperCase()
                }})</span>
            </template>
            <template v-else>
              <template v-if="acceptConnect">
                <el-icon style="color: #7ec050;margin-right: 10px">
                  <Select/>
                </el-icon>
                <span style="color: #7ec050">{{
                    activeItem.acceptProtocol.toLocaleUpperCase()
                  }} {{ $t('common.connect.server.success') }}</span>
              </template>
              <template v-else>
                <el-icon style="color: #e47470;margin-right: 10px">
                  <CloseBold/>
                </el-icon>
                <span style="color: #e47470">{{
                    activeItem.acceptProtocol.toLocaleUpperCase()
                  }} {{ $t('common.connect.server.fail') }}</span>
              </template>
            </template>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="settingss">
          <el-button size="small" @click="()=>diaTest = false">{{ $t('common.cancel') }}</el-button>
          <el-button size="small" type="primary" @click="()=>diaTest = false">{{ $t('common.confirm') }}</el-button>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import {ElMessage, ElNotification} from "element-plus";
import {settingAccountOption} from "../utils/config";
import mailLoginForm from "./components/maillLoginForm/index.vue";
import {
  getMailConfigList,
  delConfigById,
  updateConfigState,
  getDefaultMailConfig, checkConnect,
} from "../api/index";
import _store from "store2";
import TablesBlack from "@/views/AccountCom/TablesBlack.vue";
import ReceiveRule from "@/views/AccountCom/ReceiveRule.vue";
import ReceiveRuleDialog from "@/views/AccountCom/ReceiveRuleDialog.vue";
import MailAutoReply from "@/views/AccountCom/MailAutoReply.vue";
import Card from '@/components/Card.vue';
import {
  copySentMail, getEmailNumber,
  requestCustomerBlackList, requestCustomerBlackListAdd, requestCustomerBlackListDelete,
  requestEmailBlackList,
  requestEmailBlackListAdd,
  requestEmailBlackListDelete, requestEmailgetSentMail, requestEmailManage,
  saveMailReceiveRule, updateMailReceiveRule, deleteMailReceiveRule,
  queryMailReceiveRulePageList, queryMailReceiveRuleById,
  saveMailAutoReply, queryMailAutoReplyByTeamId
} from "@/api/mail";
import {emailReg} from '@/utils/statusParams'
import Dialog from "@/components/Dialog.vue";
import {emptyUrl} from "@/utils/statusParams";
import * as target from '/public/settings.json'
import {toUpperCase} from "uri-js/dist/esnext/util";
import {computed, ref} from "vue";
import {i18n} from "@/lang";
import router from "@/router";
import {QuestionFilled, Close} from "@element-plus/icons-vue";

const createDefaultAutoReplySettings = () => ({
  id: '',
  enabled: false,
  content: i18n.global.t('account_setting.auto_reply.default_content'),
  timeMode: 'always',
  startDate: '',
  startTime: '',
  endDate: '',
  endTime: '',
  onlyArchivedCustomers: false,
  mailboxes: []
})

const AUTO_REPLY_DATE_TIME_PATTERN = /^(\d{4}-\d{2}-\d{2})(?:[ T](\d{2}:\d{2})(?::(\d{2}))?)?/

const toAutoReplyMailboxList = (replyMail, mailboxOptions = []) => {
  const mailboxes = Array.isArray(replyMail)
      ? replyMail
      : String(replyMail || '').split(/[,，;；\n]+/)
  const optionByValue = new Map(mailboxOptions.map(item => [String(item.value), item.value]))
  const optionByMail = new Map(mailboxOptions.map(item => [String(item.label || '').toLowerCase(), item.value]))

  return Array.from(new Set(mailboxes
      .map(item => String(item || '').trim())
      .filter(Boolean)
      .map(item => optionByValue.get(item) ?? optionByMail.get(item.toLowerCase()) ?? item)))
}

const splitAutoReplyDateTime = (value) => {
  const match = String(value || '').match(AUTO_REPLY_DATE_TIME_PATTERN)
  if (!match) {
    return {date: '', time: ''}
  }
  return {
    date: match[1],
    time: match[2] ? `${match[2]}:${match[3] || '00'}` : ''
  }
}

const toAutoReplySettings = (autoReply, mailboxOptions) => {
  const start = splitAutoReplyDateTime(autoReply?.replyStartTime)
  const end = splitAutoReplyDateTime(autoReply?.replyEndTime)
  const hasSchedule = Boolean(start.date || start.time || end.date || end.time)

  return {
    ...createDefaultAutoReplySettings(),
    id: autoReply?.id ?? '',
    enabled: autoReply?.status === true || Number(autoReply?.status) === 1,
    content: autoReply?.replyContent ?? '',
    timeMode: hasSchedule ? 'scheduled' : 'always',
    startDate: start.date,
    startTime: start.time,
    endDate: end.date,
    endTime: end.time,
    onlyArchivedCustomers: autoReply?.isCreateCustomer === true || Number(autoReply?.isCreateCustomer) === 1,
    mailboxes: toAutoReplyMailboxList(autoReply?.replyMail, mailboxOptions)
  }
}

const toAutoReplyDateTime = (date, time) => {
  if (!date) {
    return ''
  }
  return time ? `${date} ${time}` : date
}

const createMailAutoReplyPayload = (settings, teamId, userId, mailboxOptions) => {
  const mailboxLabelByValue = new Map(mailboxOptions.map(item => [String(item.value), item.label]))
  const payload = {
    isCreateCustomer: settings.onlyArchivedCustomers ? 1 : 0,
    replyContent: settings.content || '',
    replyEndTime: settings.timeMode === 'scheduled'
        ? toAutoReplyDateTime(settings.endDate, settings.endTime)
        : '',
    replyMail: (Array.isArray(settings.mailboxes) ? settings.mailboxes : [])
        .map(item => mailboxLabelByValue.get(String(item)) ?? item)
        .filter(Boolean)
        .join(','),
    replyStartTime: settings.timeMode === 'scheduled'
        ? toAutoReplyDateTime(settings.startDate, settings.startTime)
        : '',
    status: settings.enabled ? 1 : 0,
    teamId
  }

  if (settings.id !== undefined && settings.id !== null && settings.id !== '') {
    payload.id = settings.id
  }
  if (userId !== undefined && userId !== null && userId !== '') {
    payload.userId = userId
  }
  return payload
}

const isAutoReplyRequestSuccess = (response) => (
    response?.success === true || [0, 200].includes(Number(response?.code))
)

const getAutoReplyRecord = (result) => {
  if (Array.isArray(result)) {
    return result[0] || null
  }
  return result || null
}

const RECEIVE_RULE_FIELD_CODES = {
  sender: 1,
  senderDomain: 2,
  recipient: 3,
  cc: 4,
  subject: 5,
  body: 6,
  hasAttachment: 7,
  attachmentName: 8,
  isArchived: 9,
  archivedCustomer: 10,
  archivedContact: 11,
  customerLevel: 12,
  customerSource: 13,
  intentionProduct: 14
};

const RECEIVE_RULE_OPERATOR_CODES = {
  contains: 0,
  equals: 1,
  notContains: 2,
  yes: 3,
  no: 4
};

const RECEIVE_RULE_FIELDS_BY_CODE = Object.fromEntries(
    Object.entries(RECEIVE_RULE_FIELD_CODES).map(([field, code]) => [code, field])
);

const RECEIVE_RULE_OPERATORS_BY_CODE = Object.fromEntries(
    Object.entries(RECEIVE_RULE_OPERATOR_CODES).map(([operator, code]) => [code, operator])
);

const normalizeReceiveRuleValues = (condition) => {
  const value = Array.isArray(condition?.values) && condition.values.length
      ? condition.values
      : String(condition?.value || '').split(/[,，;；\n]+/);
  return Array.from(new Set(value.map(item => String(item || '').trim()).filter(Boolean)));
};

const getReceiveRuleSign = (markActions) => {
  const actions = new Set(Array.isArray(markActions) ? markActions : []);
  if (actions.has('read') && actions.has('starred')) return 3;
  if (actions.has('starred')) return 2;
  if (actions.has('read')) return 1;
  return undefined;
};

const toReceiveRuleValueList = (value) => {
  const source = Array.isArray(value) ? value : String(value || '').split(/[,，;；\n]+/);
  return Array.from(new Set(source.map(item => String(item || '').trim()).filter(Boolean)));
};

const toReceiveRuleDetailContentList = (value) => {
  const source = Array.isArray(value) ? value : String(value ?? '').split(/[,，;；\n]+/);
  return source.map(item => String(item ?? '').trim());
};

const getReceiveRuleDetailContents = (condition, values) => {
  const options = Array.isArray(condition?.valueOptions) ? condition.valueOptions : [];
  return values.map(value => {
    const option = options.find(item => String(item?.value ?? item?.id) === value);
    const label = option?.label ?? option?.labelName ?? option?.customerLevel ?? option?.name ?? value;
    return String(label ?? value).trim() || value;
  });
};

const toReceiveRuleMarkActions = (sign, markActions) => {
  if (Array.isArray(markActions)) {
    return markActions;
  }
  if (Number(sign) === 3) return ['read', 'starred'];
  if (Number(sign) === 2) return ['starred'];
  if (Number(sign) === 1) return ['read'];
  return [];
};

const toReceiveRule = (rule) => {
  const details = [
    rule?.mailReceiveRuleDetailDtoList,
    rule?.mailReceiveRuleDetailList,
    rule?.details,
    rule?.conditions
  ].find(Array.isArray) || [];
  const hasFileAction = rule?.fileId !== undefined && rule.fileId !== null && rule.fileId !== '';
  const hasForwardAction = Boolean(toReceiveRuleValueList(rule?.forwardMail || rule?.forwardEmails).length);
  const action = ['move', 'mark', 'forward'].includes(rule?.action)
      ? rule.action
      : hasFileAction
          ? 'move'
          : hasForwardAction
              ? 'forward'
              : 'mark';

  return {
    ...rule,
    id: rule?.id,
    ruleName: rule?.name ?? rule?.ruleName ?? '',
    enabled: typeof rule?.enabled === 'boolean' ? rule.enabled : Number(rule?.status) === 1,
    conditionJoin: rule?.conditionJoin || 'all',
    conditions: details.map(detail => {
      const values = toReceiveRuleValueList(
          Array.isArray(detail?.values) ? detail.values : detail?.value ?? detail?.content
      );
      const detailContents = toReceiveRuleDetailContentList(detail?.detailContent);
      return {
        ...detail,
        field: typeof detail?.field === 'string'
            ? detail.field
            : RECEIVE_RULE_FIELDS_BY_CODE[detail?.name] || 'sender',
        operator: typeof detail?.operator === 'string'
            ? detail.operator
            : RECEIVE_RULE_OPERATORS_BY_CODE[detail?.operator] || 'contains',
        values,
        value: values.join(', '),
        valueOptions: values.map((value, index) => ({
          value,
          label: detailContents[index] || value
        }))
      };
    }),
    action,
    targetFolder: rule?.fileId ?? rule?.targetFolder ?? '',
    markActions: toReceiveRuleMarkActions(rule?.sign, rule?.markActions),
    forwardEmails: toReceiveRuleValueList(rule?.forwardMail || rule?.forwardEmails)
  };
};

const createMailReceiveRulePayload = (rule, teamId) => {
  const payload = {
    mailReceiveRuleDetailDtoList: rule.conditions.map(condition => {
      const values = normalizeReceiveRuleValues(condition);
      return {
        content: values.join(','),
        detailContent: getReceiveRuleDetailContents(condition, values).join(','),
        name: RECEIVE_RULE_FIELD_CODES[condition.field],
        operator: RECEIVE_RULE_OPERATOR_CODES[condition.operator]
      };
    }),
    name: rule.ruleName,
    status: rule.enabled ? 1 : 0,
    teamId
  };

  if (rule.id !== undefined && rule.id !== null) {
    payload.id = rule.id;
    // The update endpoint preserves omitted fields, so clear the previous action explicitly.
    payload.fileId = rule.action === 'move' ? rule.targetFolder : '';
    payload.forwardMail = rule.action === 'forward'
        ? (Array.isArray(rule.forwardEmails) ? rule.forwardEmails : []).join(',')
        : '';
    payload.sign = rule.action === 'mark' ? getReceiveRuleSign(rule.markActions) : 0;
  } else if (rule.action === 'move') {
    payload.fileId = rule.targetFolder;
  } else if (rule.action === 'forward') {
    payload.forwardMail = (Array.isArray(rule.forwardEmails) ? rule.forwardEmails : []).join(',');
  } else if (rule.action === 'mark') {
    payload.sign = getReceiveRuleSign(rule.markActions);
  }

  return payload;
};

export default {
  name: "settingAccount",
  components: {
    QuestionFilled,
    Close,
    Dialog,
    mailLoginForm,
    TablesBlack,
    Card,
    ReceiveRule,
    ReceiveRuleDialog,
    MailAutoReply
  },
  data() {
    return {
      isShowNumber: false,
      sendConnect: false,
      acceptConnect: false,
      isContent: false,
      diaTest: false,
      emptyUrl: emptyUrl,
      btnIsLoading: false,
      dialogVisibleInner: false,
      oauthProviderList: [
        {
          name: 'Google Gmail',
          oauthType: 'google',
          img: require('@/views/components/maillLoginForm/image/gmail.png'),
        },
        {
          name: 'Microsoft 365',
          oauthType: 'microsoft',
          img: require('@/views/components/maillLoginForm/image/Microsoft.png'),
        },
        {
          name: 'Outlook',
          oauthType: 'outlook',
          img: require('@/views/components/maillLoginForm/image/Outlook.png'),
        },
      ],
      enterpriseProviderList: [
        {
          name: i18n.global.t('common.email.type.txyx'),
          desc: 'exmail.qq.com',
          type: 'tengXunQiYe',
          img: require('@/views/components/maillLoginForm/image/tengXunQiYe.png'),
        },
        {
          name: i18n.global.t('common.email.type.ali'),
          desc: 'qiye.aliyun.com',
          type: 'ali',
          img: require('@/views/components/maillLoginForm/image/ali.png'),
        },
        {
          name: i18n.global.t('common.email.type.163'),
          desc: 'qiye.163.com',
          type: 'wangYiQiYe',
          img: require('@/views/components/maillLoginForm/image/wangYi.png'),
        },
        {
          name: i18n.global.t('common.email.type.other'),
          desc: i18n.global.t('account_setting.mail_provider.enterprise.other_desc'),
          wide: true,
          type: 'other',
          img: require('@/views/components/maillLoginForm/image/other.png'),
        },
      ],
      targetEmail: '',
      targetCustomer: '',
      tableDataBackEmail: [],
      table_columns_email: [{
        key: i18n.global.t("common.emailbox"),
        value: "mailBox"
      }, {key: i18n.global.t("common.date.add"), value: "createTime"}],
      tableDataBackCustomer: [],
      table_columns_customer: [{
        key: i18n.global.t("common_customer_name"),
        value: "remark"
      }, {key: i18n.global.t("common.date.add"), value: "createTime"}],
      tableData: [],
      emailList: [],
      receiveRules: [],
      receiveRulePage: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      receiveRuleLoading: false,
      receiveRuleRequestVersion: 0,
      receiveRuleStatusChangingIds: [],
      receiveRuleDialogVisible: false,
      editingReceiveRule: null,
      autoReplySettings: createDefaultAutoReplySettings(),
      autoReplySaving: false,
      autoReplyRequestVersion: 0,
      defaultEmail: "",
      activeName: "second",
      tableOption: settingAccountOption,
      tableLoading: true,
      dialog: false,
      rowData: {}, // 行数据
      knowTaskId: "", // 处理id
      mailConfigDialog: false,
      selectTypeDialog: false,
      actionMode: "add", // [add, edit]
      mailAccountType: "other",
      mailList: [
        // {img: require('@/assets/img/mail/jck.png'),  w: '26px', h: '30px', type: 'jck', text: '进出口邮箱'},
        {
          img: require("@/assets/img/mail/tx.png"),
          w: "29px",
          h: "20px",
          type: "tengXunQiYe",
          text: i18n.global.t("common.email.type.txyx"),
        },
        {
          img: require("@/assets/img/mail/qq.png"),
          w: "29px",
          h: "29px",
          type: "tengXunQQ",
          text: i18n.global.t("common.email.type.qqyx"),
        },
        {
          img: require("@/assets/img/mail/163.png"),
          w: "29px",
          h: "15px",
          type: "wangYi",
          text: i18n.global.t('common.email.type.163'),
        },
        {
          img: require("../assets/img/mail/126.png"),
          w: "29px",
          h: "16px",
          type: "126",
          text: i18n.global.t('common.email.type.126'),
        },
        {
          img: require('../assets/img/mail/263.jpg'),
          w: "29px",
          h: "16px",
          type: "263",
          text: i18n.global.t('common.email.type.263'),
        },
        // {img: require('@/assets/img/mail/gmail.png'),  w: '29px', h: '22px', type: 'gmail', text: 'Gmail'},
        // {img: require('@/assets/img/mail/outlook.png'),  w: '29px', h: '25px', type: 'outlook', text: 'Outlook'},
        // {img: require('@/assets/img/mail/exchange.png'),  w: '29px', h: '27px', type: 'exchange', text: 'Exchange'},
        {
          img: require("@/assets/img/mail/mail.png"),
          w: "29px",
          h: "26px",
          type: "other",
          text: i18n.global.t('common.email.type.other'),
        },
      ],
      showInfo: false,
      remindStatus: false,
      blackEmail: {
        current: 1,
        size: 5,
        total: 0,
      },
      blackCustomer: {
        current: 1,
        size: 5,
        total: 0,
      },
      activeItem: {},
      valueType: {
        label: i18n.global.t('common.select.targetDays', {count: 30}),
        value: '30'
      },
      optionsType: [{
        label: i18n.global.t('common.select.targetDays', {count: 30}),
        value: '30'
      }, {
        label: i18n.global.t('common.select.targetDays', {count: 90}),
        value: '90'
      }, {
        label: i18n.global.t('common.select.targetDays', {count: 180}),
        value: '180'
      }, {
        label: i18n.global.t('common.select.targetYear', {count: 1}),
        value: '365'
      }, {
        label: i18n.global.t('common.select.targetYears', {count: 3}),
        value: '1095'
      }, {
        label: i18n.global.t('common.select.all'),
        value: null
      }],
      valueTypeShow: '',
      getEmailDia: false,
      typeMail: 0,
      checkList: [],
      emailNumber: {},
      emailNumberLoading: false,
    };
  },
  computed: {
    lang() {
      return this.$store.state.system.langLocal;
    },
    teamId() {
      return this.$store.state.email.teamID;
    },
    userId() {
      const userInfo = this.$store.state.user.userInfo || {};
      return userInfo.id ?? userInfo.userId ?? userInfo.userID ?? '';
    },
    receiveRuleFolderOptions() {
      return (this.$store.state.sidebar.fileList || [])
          .filter(item => item && item.id !== undefined && item.fileName)
          .map(item => ({
            label: item.fileName,
            value: item.id
          }));
    },
    // 判断是否为 OAuth 类型（Google、Microsoft、Outlook）
    isOAuthType() {
      const oauthTypes = ['google', 'microsoft', 'outlook'];
      return oauthTypes.includes(this.mailAccountType);
    },
  },
  watch: {
    async teamId() {
      this.receiveRulePage.pageNo = 1;
      this.autoReplySettings = createDefaultAutoReplySettings();
      this.autoReplyRequestVersion += 1;
      if (this.activeName === 'receive-rule') {
        await this.getReceiveRulePage();
      }
      await this.getList();
      if (this.activeName === 'auto-reply') {
        await this.getAutoReplySettings();
      }
      await this.getDefaultMailConfig();
      await this.requestEmailBlackListApis()
      await this.requestCustomerBlackListApis()
      await this.getDefaultMailConfig();
    },
    activeName(value) {
      if (value === 'receive-rule') {
        this.getReceiveRulePage();
      }
      if (value === 'auto-reply') {
        this.getAutoReplySettings();
      }
    }
  },
  async mounted() {
    const {type} = this.$route.query
    this.valueTypeShow = type;
    if (this.valueTypeShow === 'add') {
      // Use a consumed flag to prevent duplicate dialog caused by
      // keep-alive component tree creating multiple instances
      const flagKey = '__account_setting_add_dialog__'
      const alreadyOpened = sessionStorage.getItem(flagKey)
      if (!alreadyOpened) {
        sessionStorage.setItem(flagKey, '1')
        this.selectTypeDialog = true
        this.activeName = "second"
        // Clear flag after component is stable
        this.$nextTick(() => {
          setTimeout(() => sessionStorage.removeItem(flagKey), 500)
        })
      }
      // Clean up the query param
      this.$router.replace({path: this.$route.path, query: {}}).catch(() => {})
    }

    await this.getList();
    await this.getDefaultMailConfig();
    await this.requestEmailBlackListApis()
    await this.requestCustomerBlackListApis()
  },
  methods: {
    toUpperCase,
    async getAutoReplySettings() {
      const teamId = this.teamId;
      const requestVersion = ++this.autoReplyRequestVersion;

      if (!teamId) {
        this.autoReplySettings = createDefaultAutoReplySettings();
        return;
      }

      try {
        const response = await queryMailAutoReplyByTeamId({teamId});
        if (
            !isAutoReplyRequestSuccess(response) ||
            requestVersion !== this.autoReplyRequestVersion ||
            String(teamId) !== String(this.teamId)
        ) {
          return;
        }

        const autoReply = getAutoReplyRecord(response.result);
        this.autoReplySettings = autoReply
            ? toAutoReplySettings(autoReply, this.emailList)
            : createDefaultAutoReplySettings();
      } catch {
        // The shared request layer keeps its existing error prompt behavior.
      }
    },
    async saveAutoReply() {
      const teamId = this.teamId;
      if (!teamId || this.autoReplySaving) {
        return;
      }

      this.autoReplySaving = true;
      try {
        const payload = createMailAutoReplyPayload(
            this.autoReplySettings,
            teamId,
            this.userId,
            this.emailList
        );
        const response = await saveMailAutoReply(payload);
        if (!isAutoReplyRequestSuccess(response) || String(teamId) !== String(this.teamId)) {
          return;
        }

        await this.getAutoReplySettings();
        ElMessage.success(i18n.global.t('sys.message.success.save'));
      } catch {
        // The shared request layer keeps its existing error prompt behavior.
      } finally {
        this.autoReplySaving = false;
      }
    },
    async getReceiveRulePage(page = {}) {
      const pageNo = Number(page.pageNo) || this.receiveRulePage.pageNo;
      const pageSize = Number(page.pageSize) || this.receiveRulePage.pageSize;
      const teamId = this.teamId;
      const requestVersion = ++this.receiveRuleRequestVersion;

      if (!teamId) {
        this.receiveRules = [];
        this.receiveRulePage = {pageNo, pageSize, total: 0};
        this.receiveRuleLoading = false;
        return;
      }

      this.receiveRuleLoading = true;
      try {
        const response = await queryMailReceiveRulePageList({pageNo, pageSize, teamId});
        if (
            response?.code !== 200 ||
            requestVersion !== this.receiveRuleRequestVersion ||
            String(teamId) !== String(this.teamId)
        ) {
          return;
        }

        const result = response.result || {};
        const records = Array.isArray(result) ? result : result.records || [];
        const current = Number(result.current);
        const size = Number(result.size);
        const total = Number(result.total);
        this.receiveRules = records.map(toReceiveRule);
        this.receiveRulePage = {
          pageNo: Number.isFinite(current) && current > 0 ? current : pageNo,
          pageSize: Number.isFinite(size) && size > 0 ? size : pageSize,
          total: Number.isFinite(total) && total >= 0 ? total : records.length
        };
      } catch {
        // The shared request layer keeps its existing error prompt behavior.
      } finally {
        if (requestVersion === this.receiveRuleRequestVersion) {
          this.receiveRuleLoading = false;
        }
      }
    },
    handleReceiveRulePageChange(page) {
      this.receiveRulePage.pageNo = page.pageNo;
      this.receiveRulePage.pageSize = page.pageSize;
      this.getReceiveRulePage(page);
    },
    createReceiveRule() {
      this.editingReceiveRule = null;
      this.receiveRuleDialogVisible = true;
    },
    async editReceiveRule(rule) {
      if (rule?.id === undefined || rule?.id === null) {
        return;
      }

      try {
        const response = await queryMailReceiveRuleById({id: rule.id});
        if (response?.code !== 200 || !response.result) {
          return;
        }

        this.editingReceiveRule = toReceiveRule(response.result);
        this.receiveRuleDialogVisible = true;
      } catch {
        // The shared request layer keeps its existing error prompt behavior.
      }
    },
    async saveReceiveRule(rule) {
      try {
        const teamId = this.$store.state.email.teamID;
        const payload = createMailReceiveRulePayload(rule, teamId);
        const isEditing = this.editingReceiveRule?.id !== undefined && this.editingReceiveRule?.id !== null;
        const response = await (isEditing
            ? updateMailReceiveRule(payload)
            : saveMailReceiveRule(payload));
        if (response?.code !== 200) {
          return;
        }

        this.receiveRuleDialogVisible = false;
        this.editingReceiveRule = null;
        await this.getReceiveRulePage();
        ElMessage.success(i18n.global.t('account_setting.receive_rule.saved'));
      } catch {
        // The shared request layer keeps its existing error prompt behavior.
      }
    },
    isReceiveRuleStatusChanging(id) {
      return this.receiveRuleStatusChangingIds.includes(String(id));
    },
    async toggleReceiveRuleStatus(rule) {
      if (
          rule?.id === undefined ||
          rule?.id === null ||
          this.isReceiveRuleStatusChanging(rule.id)
      ) {
        return;
      }

      const ruleId = String(rule.id);
      const enabled = !rule.enabled;
      const teamId = this.teamId;
      if (!teamId) {
        return;
      }

      this.receiveRuleStatusChangingIds = [...this.receiveRuleStatusChangingIds, ruleId];
      try {
        const response = await updateMailReceiveRule({
          id: rule.id,
          status: enabled ? 1 : 0,
          teamId
        });
        if (response?.code !== 200 || String(teamId) !== String(this.teamId)) {
          return;
        }

        Object.assign(rule, {enabled, status: enabled ? 1 : 0});
        await this.getReceiveRulePage();
        ElMessage.success(i18n.global.t('account_setting.receive_rule.status_updated'));
      } catch {
        // The shared request layer keeps its existing error prompt behavior.
      } finally {
        this.receiveRuleStatusChangingIds = this.receiveRuleStatusChangingIds.filter(id => id !== ruleId);
      }
    },
    async deleteReceiveRule(rule) {
      try {
        const response = await deleteMailReceiveRule({id: rule.id});
        if (response?.code !== 200) {
          return;
        }

        this.receiveRules = this.receiveRules.filter(item => item.id !== rule.id);
        ElMessage.success(i18n.global.t('sys.message.success.delete'));
      } catch {
        // The shared request layer keeps its existing error prompt behavior.
      }
    },
    // 判断是否为 OAuth 邮箱（Google、Microsoft、Outlook）
    isOAuthMailbox(row) {
      const oauthTypes = ['google', 'microsoft', 'outlook'];
      // 检查 oauthType 或 mailType 是否为 oauth2
      return oauthTypes.includes(row.oauthType) || row.mailType === 'auth2';
    },
    toHref() {
      // window.open(target.docUrl, "_blank")
      let newUrl = router.resolve(
          `/settingguide`
      );
      this.openNewWindow(newUrl.href);
    },
    openNewWindow(url) {
      window.open(url, "_blank");
    },
    handleClickImport(row, type) {
      // 清空状态 重置
      this.checkList = [];
      this.valueType = {
        label: i18n.global.t('common.select.targetDays', {count: 30}),
        value: '30'
      }
      this.emailNumber = {};
      this.isShowNumber = false

      this.dialogVisibleInner = true
      this.activeItem = row
      this.typeMail = type
    },
    // 导入邮件
    async handleClickSure() {
      if (this.checkList.length === 0) {
        ElMessage.warning(i18n.global.t('account.import.type'))
        return
      }
      console.log(this.valueType, 'this.valueType')
      if (this.valueType !== '') {
        const targetObj = {
          id: this.activeItem.id,
          type: this.valueType.value,
        }
        //console.log('ff', this.activeItem, targetObj)
        this.btnIsLoading = true
        this.dialogVisibleInner = false

        // 异步操作
        this.getEmailDia = true;
        // const res = this.typeMail === 1 ? await requestEmailManage(targetObj) : await requestEmailgetSentMail(targetObj)
        if (this.checkList.includes(1) && this.checkList.includes(2)) {
          await Promise.all([
            requestEmailManage(targetObj),
            requestEmailgetSentMail(targetObj)
          ]).then((res) => {
            // 更新标志
            this.$store.dispatch('countshow/getTeamAllDataApis')
            // 重新获取邮件列表
            this.valueType = {
              label: i18n.global.t('common.select.targetDays', {count: 30}),
              value: '30'
            }
            this.btnIsLoading = false
          })
        } else if (this.checkList.includes(1)) {
          await requestEmailManage(targetObj).then((res) => {
            // 更新标志
            this.$store.dispatch('countshow/getTeamAllDataApis')
            // 重新获取邮件列表
            this.valueType = {
              label: i18n.global.t('common.select.targetDays', {count: 30}),
              value: '30'
            }
            this.btnIsLoading = false
          })
        } else if (this.checkList.includes(2)) {
          await requestEmailgetSentMail(targetObj).then((res) => {
            // 更新标志
            this.$store.dispatch('countshow/getTeamAllDataApis')
            // 重新获取邮件列表
            this.valueType = {
              label: i18n.global.t('common.select.targetDays', {count: 30}),
              value: '30'
            }
            this.btnIsLoading = false
          })
        } else if (this.checkList.includes(3)) {
          await copySentMail(targetObj).then(res => {
            console.log(res, 'res')
          })
        }
      } else {
        ElMessage.error(i18n.global.t('account.import.times'))
      }
    }
    ,

    async handleChangeDefault(id) {
      const result = await updateConfigState({id, isBind: 1, teamId: this.teamId});
      if (result.code !== 200) {
        this.defaultEmail = "";
        ElMessage.error(i18n.global.t('account.import.failed'));
        return;
      }
    }
    ,
    async getDefaultMailConfig() {
      const res = await getDefaultMailConfig({teamId: this.teamId});
      if (res.code !== 200) {
        ElMessage.error(res.message);
        return;
      }
      if (res.result == null) {
        this.defaultEmail = '';
        return;
      }
      const {id} = res.result;
      console.log(res.result, 'fffffffffffff')
      this.defaultEmail = id;
    },
//个性签名弹框关闭
    handleClose() {
      this.showInfo = false;
    }
    ,
// 邮箱邮箱
// TODO:
    getList() {
      this.tableLoading = true;
      // const res = {
      //   data: {"code":200,"msg":"成功","data":[{"id":71,"sysUserId":419,"mailType":"wangYi","account":"Beats0","sendHost":"smtp.163.com","acceptHost":"imap.163.com","sendPort":465,"acceptPort":993,"acceptSsl":1,"sendSsl":1,"username":"jyl2047155291@163.com","password":"xxx","sendProtocol":"smtp","acceptProtocol":"imap","defaultEncodingS":"UTF-8","useWay":1,"createTime":"2021-04-03T22:21:00","updateTime":"2021-04-03T22:21:00","delFlag":0,"tenantId":39},{"id":110,"sysUserId":419,"mailType":"tengXunQQ","account":"","sendHost":"smtp.qq.com","acceptHost":"imap.qq.com","sendPort":465,"acceptPort":993,"acceptSsl":1,"sendSsl":1,"username":"1357097581@qq.com","password":"xxppeerzfmrebagg","sendProtocol":"smtp","acceptProtocol":"imap","defaultEncodingS":"UTF-8","useWay":1,"createTime":"2021-06-09T09:26:32","updateTime":"2021-06-09T09:26:32","delFlag":0,"tenantId":39}],"timestamp":"2021-06-09 14:28:06 870"}
      // }
      //console.log("用户信息", _store.get("userInfo"));
      return getMailConfigList({teamId: this.teamId})
          .then((res) => {
            //console.log(res.result, "邮箱列表");
            const list = res.result || [];
            this.tableData = list;
            this.emailList = list.map((item) => ({
              label: item.username,
              value: item.id,
            }));
            // if (this.emailList.length >= 1 && this.defaultEmail === "") {
            //   this.defaultEmail = this.emailList[0].value
            //   this.handleChangeDefault(this.emailList[0].value)
            // }
          })
          .finally(() => {
            this.tableLoading = false;
          });
    },
    async successCb() {
      //console.log('fff')
      this.mailConfigDialog = false;
      this.getList();
      //console.log("添加成功");
      // EventBus.$emit('handleCheckIsFirstLogin')
    }
    ,
// 选中item
    handleSelectItem(item) {
      this.mailAccountType = item.type;
      this.actionMode = "add";
      this.rowData = {};
      this.selectTypeDialog = false;
      this.mailConfigDialog = true;
    }
    ,
// 帮助
    handleGoToHelp() {
      // const url = process.env.NODE_ENV === 'development'?location.protocol+'//'+location.host+':8081':''
      // //console.log(location,"99999999999")
      // openLink(location.origin+'/html/mailhelp.html')
    }
    ,
    handleMailConfigDialogCancel(done) {
      done();
    }
    ,
// 开启、关闭
    handleChange(status, row) {
      const query = {
        id: row.id,
        useWay: row.useWay,
      };
      updateConfigState(query).then((res) => {
        if (res.code === 200) {
          this.getList();
        }
      });
    }
    ,
// 删除
    handleDel({id}) {
      //console.log("删除", id);
      this.$msgbox({
        title: i18n.global.t('tips'),
        message: `
          <div style="display: flex;justify-content: center;width: 100%;align-items: center;flex-direction: column">
        <div style="display: flex;justify-content: center;width: 100%"><img
            src="data:image/png;base64,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"/>
        </div>
        <div style="font-size: 14px;margin: 20px 0px">
        ${i18n.global.t('account.setting.message.box')}
        </div>
      </div>
          `,
        dangerouslyUseHTMLString: true,
        customClass: "customMsgBox",
        showCancelButton: true,
        confirmButtonText: i18n.global.t('common.confirm'),
        confirmButtonClass: "confirmBtn confirmButton",
        cancelButtonText: i18n.global.t('common.cancel'),
        cancelButtonClass: "confirmBtn cancelButton",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = i18n.global.t('account.setting.message.doing');
            delConfigById({id})
                .then((res) => {
                  //console.log("删除成功", res);
                  if (res.code === 200) {
                    this.$message.success(i18n.global.t('sys.message.success.delete'));
                    // EventBus.$emit('handleCheckIsFirstLogin')
                    this.defaultEmail = "";
                    this.getList();
                  }
                })
                .finally(() => {
                  done();
                  instance.confirmButtonLoading = false;
                });
          } else {
            done();
          }
        },
      })
          .then((action) => {
          })
          .catch((e) => {
          });
    }
    ,
// 编辑
    handleEdit(row) {
      console.log('handleEdit - 原始 row 数据:', JSON.parse(JSON.stringify(row)));
      
      this.actionMode = "edit";
      
      // 判断是否为 OAuth 类型的邮箱
      // 如果 mailType 是 "auth2" 或 "oauth2"，则根据 username 后缀判断具体类型
      const mailType = (row.mailType || '').toLowerCase();
      const isOAuth2 = mailType === 'auth2' || mailType === 'oauth2';
      
      if (isOAuth2 && row.username) {
        // 根据邮箱后缀判断 OAuth 类型
        const username = row.username.toLowerCase();
        let oauthType = '';
        
        // 如果是 Gmail 后缀，判定为 Google
        if (username.includes('@gmail.com') || username.includes('gmail')) {
          oauthType = 'google';
        } 
        // 如果是 Outlook 后缀，判定为 Outlook
        else if (username.includes('@outlook.com') || username.includes('outlook')) {
          oauthType = 'outlook';
        }
        // 否则都是 Microsoft（Microsoft OAuth 可以绑定任意邮箱，包括 QQ、163、hotmail、live 等）
        else {
          oauthType = 'microsoft';
        }
        
        console.log('handleEdit - OAuth2 类型判断:', {
          username,
          oauthType,
          mailType: row.mailType
        });
        
        // OAuth 类型邮箱：设置 mailAccountType 和 isOAuth 标记
        this.mailAccountType = oauthType;
        this.rowData = {
          ...row,
          isOAuth: true,
          oauthType: oauthType,
          mailType: oauthType, // 设置为具体的 OAuth 类型
        };
        console.log('handleEdit - OAuth 类型，设置 rowData:', JSON.parse(JSON.stringify(this.rowData)));
        this.mailConfigDialog = true;
        return;
      }
      
      // 非 OAuth 类型，保持原有逻辑
      this.mailAccountType = row.mailType || "other";
      this.rowData = row;
      console.log('handleEdit - 非 OAuth 类型，mailAccountType:', this.mailAccountType);
      
      this.mailConfigDialog = true;
    }
    ,
// 新增
    handleAdd() {
      this.mailAccountType = "other";
      this.mailConfigDialog = false;
      this.selectTypeDialog = true;
      this.actionMode = "add";
      this.rowData = {};
    }
    ,
    handleSelectOauthProvider(item) {
      if (!item || !item.oauthType) return;
      this.selectTypeDialog = false;

      // Google Gmail、Microsoft 365、Outlook 使用表单方式，不跳转
      if (item.oauthType === 'google' || item.oauthType === 'microsoft' || item.oauthType === 'outlook') {
        this.mailAccountType = item.oauthType;
        this.actionMode = 'add';
        this.rowData = {
          mailType: item.oauthType,
          isOAuth: true, // 标记为 OAuth 模式
          oauthType: item.oauthType, // 保存 OAuth 类型
        };
        this.mailConfigDialog = true;
        return;
      }

      // 其他 OAuth 提供商继续使用跳转方式（如果有的话）
      const path = '/oauth-demo';
      const newUrl = router.resolve(path);
      this.openNewWindow(newUrl.href);
    },
    handleSelectEnterpriseProvider(item) {
      this.selectTypeDialog = false;
      const providerType = item && item.type ? item.type : 'other';
      this.mailAccountType = providerType;
      this.actionMode = 'add';

      const presetMap = {
        tengXunQiYe: {
          mailType: 'tengXunQiYe',
          acceptProtocol: 'imap',
          acceptHost: 'imap.exmail.qq.com',
          acceptSsl: 1,
          acceptPort: 993,
          sendProtocol: 'smtp',
          sendHost: 'smtp.exmail.qq.com',
          sendSsl: 1,
          sendPort: 465,
        },
        ali: {
          mailType: 'ali',
          acceptProtocol: 'imap',
          acceptHost: 'imap.qiye.aliyun.com',
          acceptSsl: 1,
          acceptPort: 993,
          sendProtocol: 'smtp',
          sendHost: 'smtp.qiye.aliyun.com',
          sendSsl: 1,
          sendPort: 465,
        },
        wangYiQiYe: {
          mailType: 'wangYiQiYe',
          acceptProtocol: 'imap',
          acceptHost: 'imap.qiye.163.com',
          acceptSsl: 1,
          acceptPort: 993,
          sendProtocol: 'smtp',
          sendHost: 'smtp.qiye.163.com',
          sendSsl: 1,
          sendPort: 465,
        },
      };

      this.rowData = presetMap[providerType] ? {...presetMap[providerType]} : {};
      this.mailConfigDialog = true;
    },
//个性签名弹框打开
    handleSignature() {
      this.showInfo = true;
    }
    ,
//开启关闭消息提醒
    handleremindStatus(row) {
      //console.log(row);
      businessRemind(row.id, row.isRemind).then((res) => {
        if (res.code === 200) {
          this.getList();
        }
      });
    }
    ,
    async requestEmailBlackListApis() {
      const res = await requestEmailBlackList({
        pageNo: this.blackEmail.current,
        pageSize: this.blackEmail.size,
        teamId: this.teamId,
      });
      if (res.code !== 200) {
        ElMessage.error(res.message);
        return
      }
      const {records, total, size, current} = res.result;
      this.tableDataBackEmail = records;
      this.blackEmail.current = current;
      this.blackEmail.size = size;
      this.blackEmail.total = total
    }
    ,
    async addBlackEmail() {
      if (this.targetEmail !== '') {
        // if (emailReg.test(this.targetEmail)) {
        const res = await requestEmailBlackListAdd({
          mailBox: this.targetEmail,
          teamId: this.teamId
        });
        if (res.code !== 200) {
          ElMessage.error(res.message)
          return
        }
        ElMessage.success(res.message);
        this.targetEmail = "";
        this.requestEmailBlackListApis();
        // } else {
        //   ElMessage.warning('请输入正确的邮箱地址')
        // }
      } else {
        ElMessage.warning(i18n.global.t('sys.tip.input.emailbox'))
      }
    }
    ,
    async deleteBlackEmail(val) {
      const res = await requestEmailBlackListDelete({
        id: val.id,
      })
      if (res.code !== 200) {
        ElMessage.error(res.message)
        return
      }
      ElMessage.success(res.message)
      this.requestEmailBlackListApis();
    }
    ,
    handleCurrentChange(page) {
      this.blackEmail.current = page
      this.requestEmailBlackListApis()
    }
    ,


    async requestCustomerBlackListApis() {
      const res = await requestCustomerBlackList({
        pageNo: this.blackCustomer.current,
        pageSize: this.blackCustomer.size,
        teamId: this.teamId,
      })
      if (res.code !== 200) {
        ElMessage.error(res.message)
        return
      }
      const {records, total, size, current} = res.result;
      console.log(res.result, 'ffffffffffasdfasdfasfd')
      this.tableDataBackCustomer = records;
      this.blackCustomer.current = current;
      this.blackCustomer.size = size;
      this.blackCustomer.total = total
    },
    async addBlackCustomer() {
      if (this.targetCustomer !== "") {
        const res = await requestCustomerBlackListAdd({
          teamId: this.teamId,
          customerCode: this.targetCustomer,
        })
        if (res.code !== 200) {
          ElMessage.error(res.message)
          return
        }
        ElMessage.success(res.message)
        this.targetCustomer = "";
        await this.requestCustomerBlackListApis();
      } else {
        ElMessage.warning(i18n.global.t('account.setting.code'))
      }
    }
    ,
    async deleteBlackCustomer(val) {
      const res = await requestCustomerBlackListDelete({
        id: val.id
      })
      if (res.code !== 200) {
        ElMessage.error(res.message)
        return
      }
      ElMessage.success(res.message);
      this.requestCustomerBlackListApis();
    }
    ,
    handleCurrentChangeCus(page) {
      this.blackCustomer.current = page;
      this.requestCustomerBlackListApis();
    }
    ,

    // 测试连通性测试
    async handleTest(row) {
      console.log(row, 'row')
      this.activeItem = row;
      this.diaTest = true;
      this.isContent = true
      const res = await checkConnect({id: row.id})
      if (res.code !== 200) {
        ElMessage.error(res.message)
        return
      }
      const {acceptConnect, sendConnect} = res.result;
      this.sendConnect = sendConnect;
      this.acceptConnect = acceptConnect;
      this.isContent = false
    },
    async handleAboutBind(row, type) {
      let payload = {id: row.id, isBind: 1, teamId: this.teamId}
      if (type === 2) {
        payload.isBind = 0
      }
      const result = await updateConfigState(payload);
      if (result.code !== 200) {
        this.defaultEmail = "";
        ElMessage.error(i18n.global.t('account.import.failed'));
        return;
      }
      await this.getList()
    },
    async handleClickChange() {
      if (!this.checkList.includes(1) && !this.checkList.includes(2)) {
        ElMessage.error(i18n.global.t('account.email.type'));
        return
      }
      console.log(this.checkList, 'this.checkList')
      this.isShowNumber = true
      try {
        const payload = {
          id: this.activeItem.id,
          type: this.valueType.value
        }
        this.emailNumberLoading = true;
        const res = await getEmailNumber(payload)
        this.emailNumber = res.result
        this.emailNumberLoading = false
      } catch (e) {
        this.emailNumberLoading = false
      }

    }
  },
};
</script>

<style lang="less" scoped>
@import "../less/page.less";

.sp {
  margin-bottom: 8px;
}

.box {
  padding: 10px;
  background: white;

  .title {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 500;
  }

  .desc {
    margin-bottom: 8px;
  }

  .tips {
    margin-top: 10px;
    height: 20px;
    line-height: 20px;
    color: #999;
    font-size: 13px;
  }
}

.mail-provider-dialog {
  padding: 0;
  position: relative;

  :deep(.el-icon) {
    font-size: 18px;
  }

  .mail-provider-section-title {
    font-size: 13px;
    font-weight: 600;
    color: #1f2329;
    margin-bottom: 10px;
  }

  .mail-provider-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }

  .mail-provider-card {
    height: 72px;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 12px 14px;
    background: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.15s ease;

    &:hover {
      border-color: #d1d5db;
      box-shadow: 0 6px 18px rgba(17, 24, 39, 0.08);
    }
  }

  .mail-provider-card--wide {
    grid-column: auto;
    justify-self: start;
    width: fit-content;
    max-width: 100%;
  }

  .mail-provider-icon-wrap {
    width: 40px;
    height: 40px;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
  }

  .mail-provider-icon {
    width: 32px;
    height: 32px;
    object-fit: contain;
    display: block;
  }

  .mail-provider-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
  }

  .mail-provider-name {
    font-size: 14px;
    font-weight: 600;
    color: #111827;
    line-height: 20px;
  }

  .mail-provider-desc {
    font-size: 12px;
    color: #9ca3af;
    line-height: 18px;
    margin-top: 2px;
  }
}

.mail-provider-header {
  position: relative;
  padding: 0;

  :deep(.el-icon) {
    font-size: 18px;
  }

  .mail-provider-close {
    position: absolute;
    right: 6px;
    top: 6px;
    width: 28px;
    height: 28px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #9ca3af;

    &:hover {
      background: #f3f4f6;
      color: #6b7280;
    }
  }
}

.mail-provider-header-sub {
  font-size: 12px;
  margin-top: 5px;
  font-weight: 500;
  color: #6b7280;
}

.mail-provider-header-divider {
  border-bottom: 1px solid #f3f3f3;
  margin-top: 20px;
  width: 100%;
}

:deep(.mail-provider-el-dialog .el-dialog__header) {
  padding: 20px 20px 0;
  margin-right: 0;
}

:deep(.mail-provider-el-dialog .el-dialog__body) {
  padding: 12px 20px 20px;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.cursor {
  cursor: pointer;
}

.mail-create-container {
  display: flex;
  align-items: center;
  flex-direction: column;

  .mail-header-text {
    color: rgb(0, 140, 255);
    text-align: center;
    letter-spacing: 3px;
    font-size: 18px;
    margin-bottom: 35px;
  }

  .createForm {
    width: 240px;

    .mail-item {
      width: 240px;
      height: 44px;
      background: #f0f3f9;
      border-radius: 8px;
      margin-bottom: 10px;
    }

    .mailList-item-row {
      display: flex;
      align-items: center;
      min-width: 115px;

      .mail-item-text {
        font-size: 14px;
        font-weight: 500;
        color: #222222;
        margin-left: 15px;
      }
    }
  }
}

.card_box {
  padding: 8px;
}

:deep(.el-tabs__nav-scroll) {
  padding-left: 16px;
  background: white;
}

:deep(.el-tabs__header) {
  margin-bottom: 0px !important;
}

.top {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  .titles {
    margin-top: 0;
    margin-bottom: 0.5em;
    color: rgba(0, 0, 0, .85);
    font-weight: 500;
    font-size: 16px;
  }

  .bottom_input {
    width: 480px;
    min-width: 380px;
  }
}

:deep(.el-input__wrapper) {
  padding: 1px 0px 1px 11px;
}

:deep(.el-input__suffix-inner) {
  border-radius: 0px 4px 4px 0px !important;
}


:deep(.el-select__caret) {
  margin-right: 6px !important;
}

.settingss {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

:deep(.el-upload--picture-card) {
  --el-upload-picture-card-size: 58px !important;
}

:deep(.el-upload-list--picture-card) {
  --el-upload-list-picture-card-size: 58px !important;
}

.cont {
  display: flex;
  justify-content: flex-start;
  align-content: center;
  font-size: 14px;
}

.cont_test {
  display: flex;
  font-size: 13px !important;
  flex-direction: column;

  & > hr {
    margin: 10px 0;
    color: #d5d5d5;
  }

  & > div {
    padding: 8px 0px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
}

:deep(.el-select--small) {
  margin: 0px 10px;
  width: 90px !important;
}

.inner_boxs {
  width: 100%;
  display: flex;
  justify-content: space-between;
}


.sp_btn {
  border-radius: 0px 4px 4px 0px !important;
}

.col {
  color: #e8e8e8;
  margin: 0px 4px;
}

:deep(.el-empty__image img) {
  width: 54% !important;
}

.search_btn {
  text-decoration: underline;
  cursor: pointer;
  color: #5a9cf8;
  font-weight: 500 !important;
}

.inners_warning {
  display: flex;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
}

.setting_center {
  display: flex !important;
  justify-content: center !important;
}

:deep(.el-table .cell) {
  font-size: 13px !important;
  font-weight: normal !important;
}

:deep(.el-empty) {
  padding: 16px !important;
}

:deep(.el-form-item__error) {
  padding-top: 3px !important;
}
</style>
<style>
/* 加在全局样式里，或 <style scoped> 里 */
.customMsgBox .el-message-box__container {
  justify-content: center !important;
}

.customMsgBox .el-message-box__btns {
  justify-content: center !important; /* 强制按钮居中 */
}

.customMsgBox .el-message-box__btns .confirmBtn {
  margin: 0 10px; /* 按钮左右留点间距 */
}

.line-text {
  width: 350px;
  display: flex;
  align-items: center;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  margin: 20px auto 0px auto;
}

.line-text::before,
.line-text::after {
  content: '';
  flex: 1;
  height: 1px;
  background-color: #edeced;
}

.tips_bottom {
  margin-top: 10px;
  padding-left: 30px;
  font-size: 12px !important;
}
</style>
